import { render, staticRenderFns } from "./MainPageJumbotron.vue?vue&type=template&id=aa537f28"
import script from "./MainPageJumbotron.vue?vue&type=script&lang=js"
export * from "./MainPageJumbotron.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports